import React, {Fragment} from 'react';
import {connect} from "react-redux";
import {FormattedMessage, injectIntl} from "react-intl";

import {toggleUserPopup} from "../../actions/actionFunctions";

import {
  getCurrencySign,
  getPriceWithCurrency,
  getQuotePriceWithTaxes,
  getTotalPrice,
  toFixedPrice
} from "../../misc/helpers";
import ShoppingCart from "./shoppingCart";
import LoadingSpinner from "../ui/loadingSpinner";
import {getDifferentCurrencyCartItems} from "../../misc/misc2";
import ShoppingCartTaxInput from "./shoppingCartTaxInput";

class ShoppingCartTotalColumns extends ShoppingCart {

  shouldComponentUpdate(nextProps) {
    return !nextProps.showAssignQuotePopup;
  }

  toggleUserPopup = () => {
    this.props.toggleUserPopup({
      userPopupOpened: true
    })
  };

  getTaxColumn = (pricingIsLocked, taxObject, taxObjectIndex) => {
    const {fabricatorSettings, intl, language} = this.props;
    const showIncluded = !pricingIsLocked && (+taxObject.materialTax > 0);
    const taxTotal = taxObject.materialTax.toFixed(2); // always round to 23.65, even if it is 23.00
    if (taxTotal <= 0 && !fabricatorSettings.sureTax) {
      return null
    }
    const taxName = taxObject.nameIntl && taxObject.nameIntl[language]
      ? taxObject.nameIntl[language]
      : (taxObject.state || intl.formatMessage({id: "shoppingCart.totalColumnsTax"})) + (showIncluded
      ? this.props.fabricatorData.isLowes
        ? intl.formatMessage({id: "shoppingCart.totalColumnsTaxIncludedLowes"})
        : intl.formatMessage({id: "shoppingCart.totalColumnsTaxIncluded"})
      : "");
    return (
      <div className="dcart-column" key={taxObjectIndex}>
        <h3 className="dcart-column__title">{taxName}</h3>
        {pricingIsLocked
          ? <span className="price price--locked" onClick={this.toggleUserPopup}>
                <FormattedMessage id="shoppingCart.totalColumnsTaxPricingLocked"/>
              </span>
          : fabricatorSettings.sureTax
            ? <ShoppingCartTaxInput taxTotal={taxTotal}/>
            : <p className="dcart-column__value">{getPriceWithCurrency(fabricatorSettings, taxTotal)}</p>
        }
      </div>
    )
  }

  render() {
    const {fabricatorSettings, isPhoneNumberValidated, discountSections, showAllQuotesCartItemsList,
      quotes, activeQuoteIndex, intl, fabricatorData, sureTaxLoading, jobId} = this.props;

    if (fabricatorData.isAmericanImport) {
      return null
    }

    const {isBackend, canSaveQuote} = document.kvConfig;
    const totalPrice = getTotalPrice();
    let grandTotal = getQuotePriceWithTaxes(totalPrice, discountSections);
    const pricingIsLocked = (fabricatorSettings.leadCaptureOnQuote || fabricatorSettings.leadCaptureShoppingCart)
      && !(isBackend && jobId && canSaveQuote) && !isPhoneNumberValidated;

    let allTaxes = totalPrice.priceTaxes.length
      ? totalPrice.priceTaxes
      : [{materialTax: totalPrice.materialTaxes}];
    let instTaxes = totalPrice.installationTaxes;
    // console.log("allTaxes", allTaxes);

    const showTaxes = !sureTaxLoading && (pricingIsLocked || allTaxes.some(tax => tax.materialTax > 0)
        || (fabricatorSettings.sureTax && isPhoneNumberValidated && jobId)) // show even if it is 0 for sureTax
      && !(this.props.showUnlockCalculations && !this.props.showTotalItems.includes("tax"));
    let subTotalPrice = 0;
    if (quotes.length > 1 && !showAllQuotesCartItemsList) {
      //todo remove
      const quoteTotalPrice = getTotalPrice(activeQuoteIndex);
      // subTotalPrice = getQuotePriceWithTaxes(quoteTotalPrice, discountSections);
      subTotalPrice = quoteTotalPrice.materialPrice;
      allTaxes = quoteTotalPrice.priceTaxes.length
        ? quoteTotalPrice.priceTaxes
        : [{materialTax: quoteTotalPrice.materialTaxes}];
      instTaxes = quoteTotalPrice.installationTaxes;
    }
    subTotalPrice = subTotalPrice.toFixed(2); // always round to 23.65, even if it is 23.00
    grandTotal = grandTotal.toFixed(2); // always round to 23.65, even if it is 23.00

    const insideQuote = Number.isInteger(activeQuoteIndex);
    const addedCountertops = insideQuote
      ? this.props.cartItems.filter(cItem => cItem.currentQuote === activeQuoteIndex && cItem.partId.includes("countertop"))
      : this.props.cartItems.filter(cItem => cItem.partId.includes("countertop"));
    const totalCountertopsQuantity = addedCountertops.reduce(((accumulator, cItem) => accumulator + cItem.quantity), 0);
    const avgPerSqftPrice = fabricatorSettings.showAveragePrice ? Math.round10(grandTotal / totalCountertopsQuantity, -2) : null;
    //const avgPerSqftPrice = totalCountertopsQuantity;

    const differentCurrencyObjects = getDifferentCurrencyCartItems(fabricatorSettings, this.props.cartItems);

    return (
      <Fragment>
        {sureTaxLoading ? (
          <div className="dcart-column dcart-column--loader">
            <LoadingSpinner size="smaller"/>
          </div>
        ) : null}
        {showTaxes && !sureTaxLoading ? allTaxes.map((taxObject, taxObjectIndex) => {
          return this.getTaxColumn(pricingIsLocked, taxObject, taxObjectIndex)
        }) : null}
        {instTaxes ? (
          <div className="dcart-column">
            <h3 className="dcart-column__title">
              {intl.formatMessage({id: "shoppingCart.installationTaxesTitle"}) +
              (!pricingIsLocked && (+instTaxes > 0)
                ? this.props.fabricatorData.isLowes
                  ? intl.formatMessage({id: "shoppingCart.totalColumnsTaxIncludedLowes"})
                  : intl.formatMessage({id: "shoppingCart.totalColumnsTaxIncluded"})
                : "")}
            </h3>
            {pricingIsLocked
              ? <span className="price price--locked" onClick={this.toggleUserPopup}>
                <FormattedMessage id="shoppingCart.totalColumnsTaxPricingLocked"/>
              </span>
              : <p className="dcart-column__value">{getPriceWithCurrency(fabricatorSettings, instTaxes.toFixed(2))}</p>
            }
          </div>
        ) : null}
        {(quotes.length > 1) && !showAllQuotesCartItemsList ? (
          <div className="dcart-column">
            <h3 className="dcart-column__title"><FormattedMessage id="shoppingCart.totalColumnsSubTotal"/></h3>
            {pricingIsLocked
              ? <span className="price price--locked" onClick={this.toggleUserPopup}>
                  <FormattedMessage id="shoppingCart.totalColumnsTotalPricingLocked"/>
                </span>
              : <p className="dcart-column__value">{getPriceWithCurrency(fabricatorSettings, subTotalPrice)}</p>
            }
          </div>
        ) : null}
        {avgPerSqftPrice ? (
          <div className="dcart-column">
            <h3 className="dcart-column__title"><FormattedMessage id="shoppingCart.totalColumnsAveragePrice"/></h3>
            <p className="dcart-column__value">
              {pricingIsLocked
                ? <span className="price price--locked" onClick={this.toggleUserPopup}>
                  <FormattedMessage id="shoppingCart.totalColumnsTotalPricingLocked"/>
                </span>
                : getPriceWithCurrency(fabricatorSettings, avgPerSqftPrice)
              }
            </p>
          </div>
        ) : null}
        {!differentCurrencyObjects.length || (this.props.showUnlockCalculations && !this.props.showTotalItems.includes("total")) ? null : (
          differentCurrencyObjects.map(currObject => {
            const currentTotal = getTotalPrice(null, true, currObject.cartItems);
            const total = toFixedPrice(getQuotePriceWithTaxes(currentTotal, discountSections), true)
            return (
              <div className="dcart-column" key={currObject.currency}>
                <h3 className="dcart-column__title"><FormattedMessage id="shoppingCart.totalColumnsTotal"/></h3>
                {pricingIsLocked
                  ? <span className="price price--locked" onClick={this.toggleUserPopup}>
                  <FormattedMessage id="shoppingCart.totalColumnsTotalPricingLocked"/>
                </span>
                  : <p className="dcart-column__value">{getCurrencySign(currObject.currency, fabricatorSettings) + total}</p>
                }
              </div>
            )
          })
        )}
        {this.props.showUnlockCalculations && !this.props.showTotalItems.includes("total") ? null : (
          <div className="dcart-column">
            <h3 className="dcart-column__title"><FormattedMessage id="shoppingCart.totalColumnsTotal"/></h3>
            {pricingIsLocked
              ? <span className="price price--locked" onClick={this.toggleUserPopup}>
                  <FormattedMessage id="shoppingCart.totalColumnsTotalPricingLocked"/>
                </span>
              : (
                <p className="dcart-column__value">
                  {getPriceWithCurrency(fabricatorSettings, grandTotal, null, false, true)}
                </p>
              )
            }
          </div>
        )}
      </Fragment>
    )
  }
}

const mapStateToProps = (store) => {
  const {showAllQuotesCartItemsList, cartItems, sureTax, sureTaxLoading} = store.cartState;
  const {jobId} = store.serverState;
  return {
    isPhoneNumberValidated: store.userState.isPhoneNumberValidated,
    fabricatorSettings: store.fabricatorState.settings,
    showTotalItems: store.unlockCalculationsState.showTotalItems,
    showUnlockCalculations: store.unlockCalculationsState.showUnlockCalculations,
    cartItems,
    showAllQuotesCartItemsList,
    instList: store.instState.instList,
    fabricatorTaxes: store.fabricatorState.fabricatorTaxes,
    discountSections: store.priceWorksheetState.discountSections,
    fabricatorData: store.fabricatorState,
    quotes: store.quotesState.quotes,
    activeQuoteIndex: store.quotesState.activeQuoteIndex,
    language: store.serverState.language,
    showAssignQuotePopup: store.assignQuoteState.showAssignQuotePopup,
    sureTax, // update component after api call
    sureTaxLoading, // update component after api call
    jobId,
  };
};

const mapDispatchToProps = {
  toggleUserPopup,
};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(ShoppingCartTotalColumns)
)
